import { Dropdown, DropdownItem, DropdownList, Input } from '@cokitchen/cokitchen-components';
import React, { Fragment, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { FILTER_LIST, ROUTE_KEYS, ROUTE_PREFIX } from 'utils/constants';
import useDashboardContext from 'contexts/dashboard.context';
import { ENUM_SEARCH_TYPE } from 'utils/enum';
import { ReactComponent as FilterIcon } from 'assets/icons/filter.svg';

const HeaderInput = () => {
  const {
    searchValue,
    setSearchValue,
    setSearchFilter,
    setShowMobileSidebar,
    searchFilter,
    permissions
  } = useDashboardContext();
  const [showDropdown, setShowDropdown] = useState(false);
  const [info, setInfo] = useState('');
  const { pathname } = useLocation();

  const { type, search_value } = useParams();

  const navigate = useNavigate();
  const goToSearch = () => {
    const route = `${ROUTE_PREFIX.FOOD}/search/${searchValue}/${searchFilter}`;
    if (window.location.pathname === encodeURI(route)) return;
    setShowMobileSidebar(false);
    navigate(`${ROUTE_PREFIX.FOOD}/search/${searchValue}/${searchFilter}`);
  };
  useEffect(() => {
    if (!(searchFilter && searchValue)) return;
    const searchTimer = setTimeout(() => goToSearch(), 1500);

    return () => {
      clearTimeout(searchTimer);
    };
  }, [searchFilter, searchValue]);

  useEffect(() => {
    setSearchFilter(type as ENUM_SEARCH_TYPE);
    setSearchValue(search_value ?? '');
  }, [type, search_value]);

  const handleClick = (item: ENUM_SEARCH_TYPE) => {
    setSearchFilter(item);
    setShowDropdown(false);
  };

  useEffect(() => {
    if (!pathname.includes(ROUTE_KEYS.KITCHEN_LIST) && searchValue && !searchFilter) {
      setInfo('Select A Filter');
    } else {
      setInfo('');
    }
  }, [searchFilter, searchValue]);
  const canSearch = permissions.canSearch;

  return (
    <Fragment>
      <div className='header__search'>
        {canSearch && (
          <Input
            placeholder={
              pathname.includes(ROUTE_KEYS.KITCHEN_LIST)
                ? 'Search kitchens'
                : searchFilter
                ? `Search ${searchFilter.split('_').join(' ')}`
                : 'Select a filter'
            }
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            className=''
            small
          />
        )}
        {!pathname.includes(ROUTE_KEYS.KITCHEN_LIST) && (
          <Dropdown
            visible={showDropdown}
            content={
              <FilterIcon
                className={` header__search__icon ${searchFilter ? 'text-red-5' : 'text-gray-4'}`}
                onClick={() => setShowDropdown(!showDropdown)}
              />
            }
            onClickOutside={() => setShowDropdown(false)}>
            <DropdownList>
              {FILTER_LIST.map((item, i) => (
                <DropdownItem
                  key={i}
                  onClick={() => handleClick(item.value)}
                  className={`capitalize ${searchFilter === item.value && 'text-red-5'}`}>
                  {item.name}
                </DropdownItem>
              ))}
            </DropdownList>
          </Dropdown>
        )}
      </div>
      {info && <p className='text-yellow-6 text-xs italic font-semibold'> {info}</p>}
    </Fragment>
  );
};

export default HeaderInput;
